<script>
export default {
  computed: {
    items() {
      const routes = {
        EDIT_WIZARD_DETAILS: 'settings_teams_edit',
        EDIT_WIZARD_AGENTS: 'settings_teams_edit_members',
        EDIT_WIZARD_FINISH: 'settings_teams_edit_finish',
      };

      const steps = [
        'EDIT_WIZARD_DETAILS',
        'EDIT_WIZARD_AGENTS',
        'EDIT_WIZARD_FINISH',
      ];

      return steps.map(step => {
        return {
          title: this.$t(`TEAMS_SETTINGS.EDIT_FLOW.${step}.TITLE`),
          body: this.$t(`TEAMS_SETTINGS.EDIT_FLOW.${step}.BODY`),
          route: routes[step],
        };
      });
    },
  },
};
</script>

<template>
  <div class="wizard-page mx-2 flex flex-col gap-6 mb-8">
    <div
      class="wizard-shell grid grid-cols-1 lg:grid-cols-8 rounded-xl border min-h-[43rem]"
    >
      <woot-wizard
        class="hidden lg:block col-span-2 h-fit py-8 px-6 border-r border-slate-200"
        :items="items"
      />
      <router-view />
    </div>
  </div>
</template>

<style scoped>
.wizard-page,
.dark .wizard-page {
  background: #ffffff !important;
}

.wizard-shell {
  background: #ffffff !important;
  border-color: #e5e7eb !important;
}

:deep(.text-n-slate-12) {
  color: #111827 !important;
}
:deep(.text-n-slate-11) {
  color: #4b5563 !important;
}
:deep(.bg-n-background),
:deep(.bg-n-solid-1),
:deep(.bg-n-solid-2) {
  background: #ffffff !important;
}
:deep(.border-n-weak) {
  border-color: #e5e7eb !important;
}
</style>
